"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmIcon = void 0;
const react_1 = __importDefault(require("react"));
const Theme_1 = require("../../Theme/Theme");
const ConfirmIcon = (_a) => {
    var { onClick } = _a, props = __rest(_a, ["onClick"]);
    return (react_1.default.createElement("svg", Object.assign({ width: "34", height: "34", viewBox: "0 0 34 34", fill: "none", xmlns: "http://www.w3.org/2000/svg", onClick: onClick }, props),
        react_1.default.createElement("path", { d: "M32.5 17C32.5 20.4121 31.3741 23.7288 29.297 26.4358C27.2198 29.1428 24.3075 31.0887 21.0117 31.9719C17.7159 32.855 14.2208 32.6259 11.0684 31.3201C7.91606 30.0144 5.28265 27.7049 3.57661 24.75C1.87057 21.7951 1.18724 18.3597 1.6326 14.9768C2.07797 11.594 3.62714 8.45255 6.03984 6.03985C8.45255 3.62714 11.594 2.07797 14.9768 1.6326C18.3597 1.18724 21.7951 1.87057 24.75 3.57661", stroke: Theme_1.theme.palette.AGRI_GREEN_100, strokeWidth: "3", strokeLinecap: "round" }),
        react_1.default.createElement("path", { d: "M11.2344 15.1137L17.3594 21.2377L33.9984 4.59863", stroke: Theme_1.theme.palette.AGRI_GREEN_100, strokeWidth: "3", strokeLinecap: "round" })));
};
exports.ConfirmIcon = ConfirmIcon;
